import { customAxios, FDV_URL, IDUSUARIO, USERNAME } from '../constants';
import { FETCH_PEDIDOS_COLORES,FETCH_PEDIDOS_USO,FETCH_PROFORMA_COLOR,SAVE_PEDIDOS_COLOR, SAVE_PEDIDOS_USO, DELETE_PEDIDOS_COLORES} from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchPedidosColores(numFDV,numPedido  ) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      nurFichaVtaPedido: numPedido,
    },
  };
  // http://localhost:8080/sid-ficha-venta/ficha-venta/fichas-venta/000000030489/colores-pedido?numPedidoVeh=24.90856
  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/colores-pedido`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PEDIDOS_COLORES,
    payload: request,
  };
}

export function fetchPedidosUso(numFDV,numPedido  ) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      numPedidoVeh: numPedido,
    },
  };
  // http://localhost:8080/sid-ficha-venta/ficha-venta/fichas-venta/000000030489/usos-pedido?numPedidoVeh=24.90856
  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/usos-pedido`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PEDIDOS_USO,
    payload: request,
  };
}

export function fetchProformaColor(numFDV,numProforma  ) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };
  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/proformas/${numProforma}/colores`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PROFORMA_COLOR,
    payload: request,
  };
}

//GUARDAR COLOR PEDIDOS
export function savePedidoColor(numFDV,arrayObjetosDeColores) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
  };

  const data = arrayObjetosDeColores;

  const request = customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/pedidos-colores`,data ,config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SAVE_PEDIDOS_COLOR,
    payload: request,
  };
}

//GUARDAR COLOR USOS
export function savePedidoUso(numFDV,numPedido,codAvtaFamUso,nurFichaVtaPedido,numPedidoVeh,descAVtaFamUso) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
  };


  const data = {
      codAvtaFamUso: codAvtaFamUso,
      numPedidoVeh: numPedido,
      nurFichaVtaPedido: nurFichaVtaPedido,
      numPedidoVeh:numPedidoVeh,
      descAVtaFamUso:descAVtaFamUso
  };

  const request = customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/pedidos/${numPedido}/usos`,data ,config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SAVE_PEDIDOS_USO,
    payload: request,
  };
}

//INACTIVAR COLOR USOS
export function deletePedidoUso(numFDV,numPedido,numColor ) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
  };

  const request = customAxios.delete(`${FDV_URL}/ficha-venta/fichas-venta/${numFDV}/pedidos/${numPedido}/colores/${numColor}`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))
  
  return {
    type: DELETE_PEDIDOS_COLORES,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/PedidosColores.js